import React, { useMemo } from 'react';
import * as Recharts from 'recharts';

import ChartCard from '../../ChartComponents/ChartCard';
import ChartTooltip from '../../ChartComponents/ChartTooltip';
import Info from '../../../../components/Info';
import {
  axisTick,
  chartMargin,
  formatAxisTime,
  tickEvery,
} from '../chartShared';
import style from '../style.module.scss';
import countStyle from './style.module.scss';

const CountChart = ({ data }) => {
  const countTimeline = data?.countTimeline || [];

  const avgPeople = useMemo(() => {
    if (!countTimeline.length) return null;
    const sum = countTimeline.reduce((acc, { count }) => acc + (Number(count) || 0), 0);
    return Math.round(sum / countTimeline.length);
  }, [countTimeline]);

  if (!countTimeline.length) {
    return null;
  }

  return (
    <ChartCard
      title={(
        <Info
          label="Count"
          content="Total detections per scan session"
          className="ml-2"
        />
      )}
      header={avgPeople != null && (
        <span className={countStyle.avgHeader}>
          {`Avg ${avgPeople} people / scan`}
        </span>
      )}
    >
      <div className={style.chartFix}>
        <Recharts.ResponsiveContainer width="100%" height={400}>
          <Recharts.BarChart
            data={countTimeline}
            margin={chartMargin}
            isAnimationActive={false}
          >
            <Recharts.CartesianGrid strokeDasharray="3 3" stroke="#E8E8E8" vertical={false} />
            <Recharts.XAxis
              dataKey="time"
              type="category"
              tickLine
              axisLine={{ stroke: '#B7B8BA' }}
              interval={tickEvery(countTimeline.length)}
              tick={axisTick}
              tickFormatter={formatAxisTime}
            />
            <Recharts.YAxis
              tickLine
              axisLine={{ stroke: '#B7B8BA' }}
              width={52}
              tick={axisTick}
              label={{
                value: 'Detections',
                angle: -90,
                position: 'insideLeft',
                style: { fill: '#4E5155', fontSize: 12, textAnchor: 'middle' },
              }}
            />
            <Recharts.Tooltip
              content={<ChartTooltip />}
              labelFormatter={(label) => `Scan ${label}`}
              cursor={false}
            />
            <Recharts.Bar
              dataKey="count"
              name="Count"
              fill="#FFAE20"
              radius={[4, 4, 0, 0]}
            />
          </Recharts.BarChart>
        </Recharts.ResponsiveContainer>
      </div>
    </ChartCard>
  );
};

export default CountChart;
